import React from 'react';
import { MobileRouter } from './mobile-router';

export const MobileExperience: React.FC = () => {
    return <MobileRouter />;
};
